module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Video-camera-7b743a57f7ca8bdaa5662dd1c6b84891.svg";